var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "459.000000pt",
    height: "510.000000pt",
    viewBox: "0 0 459.000000 510.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,510.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2229 4847 c-20 -8 -49 -23 -65 -35 -16 -11 -504 -497 -1085 -1079 -1141 -1144 -1079 -1075 -1079 -1183 0 -108 -63 -39 1084 -1188 613 -614 1080 -1075 1106 -1090 60 -36 173 -38 236 -5 48 26 100 82 122 132 20 47 18 145 -3 196 -12 30 -232 255 -843 867 l-826 828 1759 2 1760 3 51 27 c83 44 132 113 141 202 10 102 -40 198 -132 248 l-50 28 -1762 0 c-970 0 -1763 3 -1763 7 0 4 371 379 824 833 610 610 829 835 841 865 21 51 23 149 3 196 -22 50 -74 107 -122 131 -51 26 -148 33 -197 15z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.25f455c5c60e9aa422e7a3750d3150c6.svg";
export { ForwardRef as ReactComponent };